module.exports = __webpack_public_path__ + "static/img/footer_icon_youtube.68bcbcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/footer_icon_youtube.png
// module id = Oli8
// module chunks = 10